module.exports = __webpack_public_path__ + "static/media/HighlightGoodOptimized.60903691.webp";